module.exports = __webpack_public_path__ + "img/fwjl.a08530de.png";